import type { Editor, Range } from "@tiptap/core"
import { Extension } from "@tiptap/core"
import { PluginKey } from "@tiptap/pm/state"
import type { Transaction } from "@tiptap/pm/state"
import { Suggestion, type SuggestionOptions } from "@tiptap/suggestion"
import {
  SuggestionMenu,
  createSuggestionRender
} from "../../chakra/rich-text-editor-menu"
import type { SlashInsertionItem } from "./slash-insertion-items"

export const slashInsertionPluginKey = new PluginKey("pathwrightSlashInsertion")

export type SlashInsertionExtensionOptions = {
  getItems: (query: string) => SlashInsertionItem[]
  shouldShow?: (args: {
    editor: Editor
    range: Range
    query: string
    text: string
    transaction: Transaction
  }) => boolean
}

/**
 * Chakra-style slash commands: @tiptap/suggestion + SuggestionMenu
 * (see chakra-ui/apps/compositions rich-text-editor-with-slash-commands).
 */
export const SlashInsertionExtension = Extension.create<SlashInsertionExtensionOptions>(
  {
    name: "pathwrightSlashInsertion",

    addOptions() {
      return {
        getItems: () => [],
        shouldShow: () => true
      }
    },

    addProseMirrorPlugins() {
      const extension = this

      return [
        Suggestion<SlashInsertionItem, SlashInsertionItem>({
          editor: this.editor,
          pluginKey: slashInsertionPluginKey,
          char: "/",
          allowSpaces: false,
          allowedPrefixes: [" ", "\n", "\t", "\u00A0"],
          command: ({ editor, range, props }) => {
            props.execute({ editor, range })
          },
          items: ({ query }) => extension.options.getItems(query),
          shouldShow: (args) => extension.options.shouldShow?.(args) ?? true,
          render: createSuggestionRender(
            SuggestionMenu
          ) as unknown as NonNullable<
            SuggestionOptions<
              SlashInsertionItem,
              SlashInsertionItem
            >["render"]
          >
        })
      ]
    }
  }
)
